export default {
    namespaced: true,
    state: {
        filter: {},
        cookieName: ''
    },
    getters: {
        getFilter: state => state.filter,
        getCookieName: state => state.cookieName,
        getCurrentCustomer: state => state.filter.customer,
        getCurrentProject: state => state.filter.project,
        getUnassigned: state => state.filter.unassigned
    },
    mutations: {
        SET_OWNER_COMPANY(state, owner_company) {
            state.filter.owner_company = owner_company;
        },
        SET_OPTION(state, option) {
            state.filter.option = option;
        },
        SET_CALENDAR_VIEW(state, activeView) {
            state.filter.activeView = activeView;
        },
        SET_HOUR_STATUS(state, status) {
            state.filter.status = status;
        },
        SET_CALENDAR_NAVIGATION(state, navigation) {
            state.filter.navigation = navigation;
        },
        SET_VAT(state, vats) {
            state.filter.tax_exists = vats.tax_exists;
            state.filter.tax_exempt = vats.tax_exempt;
            state.filter.btw_reversed_charge = vats.btw_reversed_charge;
        },
        setCurrentCustomer(state, currentCustomer) {
            state.filter.customer = currentCustomer;
        },
        SET_UNASSIGNED(state, value) {
            state.filter.unassigned = value;
        },
        SET_SUPPLIER(state, supplier) {
            state.filter.supplier = supplier;
        },
        SET_CUSTOMER_PROJECT(state, data) {
            state.filter.customer = data.customer;
            state.filter.project = data.project;
        },
        SET_INVOICE_CUSTOMER_PROJECT(state, data) {
            state.filter.recipient_customer = data.recipient_customer;
            state.filter.project = data.project;
        },
        SET_PAYMENT_TYPE(state, payment_type) {
            state.filter.payment_type = payment_type;
        },
        SET_CREATED_BY(state, created_by) {
            state.filter.created_by = created_by;
        },
        SET_BALANCE_SHEET_SORTING(state, balance_sheet_ordering) {
            state.filter.balance_sheet_ordering = balance_sheet_ordering;
        },
        SET_UPDATE_FILTER_BALANCE_SHEET(state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_TRANSACTION_TYPE(state, transaction_type) {
            state.filter.status = transaction_type;
        },
        SET_TRANSACTION_AMOUNT (state, amount_type) {
            state.filter.amount_type = amount_type
        },
        SET_COST_TYPE (state, cost_type) {
            state.filter.cost_type = cost_type
        },
        SET_COST_STATUS (state, cost_status) {
            state.filter.status = cost_status
        },
        SET_COST_SEARCH (state, search_term) {
            state.filter.search = search_term
        },
        SET_CONTACT_ACTIVE (state, is_archived) {
            state.filter.is_archived = is_archived
        },
        SET_CONTACT_TYPE (state, contact_type) {
            state.filter.contact_type = contact_type
        },
        SET_CONTACT_SORTING (state, ordering) {
            state.filter.ordering = ordering
        },
        SET_UPDATE_FILTER_HOURS (state) {
            state.filter = Object.assign({},state.filter)
        }, 
        SET_TRIP_TYPE (state, type) {
            state.filter.type = type
        },
        SET_TRANSPORT_TYPE (state, transport_type) {
            state.filter.transport_type = transport_type
        },
        SET_CAR (state, car) {
            state.filter.car = car;
        },
        SET_BANK_ACCOUNT (state, account) {
            state.filter.account = account
        },
        SET_DOCUMENT_TYPE (state, document_type) {
            state.filter.type = document_type;
        },
        SET_UPDATE_FILTER_COSTS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_CONTACTS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_TRIPS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_BANK (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_INVOICES (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_DOCUMENTS (state) {
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_HOURS_REPORT (state) {
            if (state.filter.start_date == null || state.filter.end_date == null) {
                state.filter.end_date = new Date().format('Y-m-d');
                state.filter.start_date = new Date();
                state.filter.start_date.setDate(state.filter.start_date.getDate() -7); // default range is 1 week
                state.filter.start_date = state.filter.start_date.format('Y-m-d');
                state.filter.option = 'any';
            }
            state.filter = Object.assign({}, state.filter);
        },
        SET_START_END_DATE (state, dates) {
            state.filter.start_date = dates.start_date;
            state.filter.end_date = dates.end_date
        },
        SET_COOKIES (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_COOKIE_NAME (state, cookieName) {
            state.cookieName = cookieName
        },
        LOAD_COOKIE (state) {
            state.filter = this.getters.getRoot.$cookies.get(state.cookieName) || {};
        },
        /**
       * SET_FILTER
       * @param {*} state 
       * @param {*} payload {filter_name, filter_value}
       */
        SET_FILTER (state, payload) {
            payload.filters.forEach(filter_item => {
                state.filter[filter_item.name] = filter_item.value
            });
        },
        SET_REFRESH_FILTERED (state) {
            state.filter = Object.assign({}, state.filter)
        },
    },
    actions: {
        setCookienameAndReadCookie ({commit}, cookieName) {
            commit('SET_COOKIE_NAME', cookieName)
            commit('LOAD_COOKIE', cookieName)
        },
        updateFilter ({ commit }, payload) {
            commit('SET_FILTER', payload)
            if (payload.refresh) {
                commit('SET_REFRESH_FILTERED')
            }
        }
    }
};
